/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Flag_Not_ChangeableInputs */

const en_error_payment_flag_not_changeable = /** @type {(inputs: Error_Payment_Flag_Not_ChangeableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payment flag of this order cannot be changed in its current status.`)
};

/**
* | output |
* | --- |
* | "The payment flag of this order cannot be changed in its current status." |
*
* @param {Error_Payment_Flag_Not_ChangeableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_payment_flag_not_changeable = /** @type {((inputs?: Error_Payment_Flag_Not_ChangeableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Flag_Not_ChangeableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_payment_flag_not_changeable(inputs)
});